(function() {
  // Only run on the design studio page
  var container = document.querySelector('.custom-html');
  if (!container) return;
  
  // Check if we're on the design-studio page
  var pageHandle = document.body.className;
  if (pageHandle.indexOf('design-studio') === -1) return;
  
  // Build iframe URL with brand/style params
  var baseUrl = 'https://tpn-pricing-3a3e9232.viktor.space/designer';
  var params = new URLSearchParams(window.location.search);
  var brand = params.get('brand');
  var style = params.get('style');
  if (brand && style) {
    baseUrl += '?brand=' + encodeURIComponent(brand) + '&style=' + encodeURIComponent(style);
  }
  
  // Create and inject iframe
  var iframe = document.createElement('iframe');
  iframe.id = 'design-studio-iframe';
  iframe.src = baseUrl;
  iframe.style.cssText = 'width:100%;height:90vh;border:none;display:block;';
  iframe.allow = 'clipboard-read; clipboard-write';
  iframe.loading = 'eager';
  
  container.innerHTML = '';
  container.style.cssText = 'width:100%;padding:0;margin:0;';
  container.appendChild(iframe);
  
  // Remove container padding
  var parent = container.closest('[class*="section-id-"]');
  if (parent) {
    parent.classList.remove('fully-spaced-row--medium');
    parent.classList.add('container');
  }
})();
